import { EntityStatus } from '../../../core/interfaces/entity-status';
import { Enum } from '../../../core/interfaces/object-enum';

export class WorkflowHistoryStatusEnum extends Enum {
  static SUCCESS = new EntityStatus('Success', 'SUCCESS', 'success');
  static QUEUED = new EntityStatus('Queued', 'QUEUED', 'info');
  static RUNNING = new EntityStatus('Running', 'RUNNING', 'success');
  static CANCELLED = new EntityStatus('Cancelled', 'CANCELLED', 'warning');
  static FAILED = new EntityStatus('Failed', 'FAILED', 'error');
}

export class WorkflowRunHistoryItem {
  startedTs: number;
  runTime: number;
  failureMessage: string;
  status: EntityStatus;
}
